import React, {useState} from "react";
import {Menu, MenuItem, IconButton, ListItemIcon, ListItemText, useTheme, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomChipComponent from "../../../core/components/common/custom-chip.component";
import {useNavigate} from "react-router-dom";
import UpdateIcon from "@mui/icons-material/Update";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import UpdateStatusDialog from "./update-status.dialog";
import { useGuard } from "../../RBACPlugin";
import { permissions } from "../../../core/components/common/variables/static_variables";


const CustomMenuPopperComponent = (props) => {
    const {data, setSelectedPort, setOpen, theme, customIconStyles} = props;

    const navigate = useNavigate();

    const {hasPermission} = useGuard();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    }
    
    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleUpdateStatus = () => {
        setSelectedPort(data);
        setOpen(true);
    }

    const menuItems = [
        {
            icon: <VisibilityIcon fontSize="small" sx={{color: theme.palette.primary.main}} />,
            label: "View Details",
            onClick: (e) =>  navigate(`/ports/view?id=${data.portUid}`),
            requiredPermission: permissions.ports.VIEW_PORT,
        },
        {
            icon: <BorderColorIcon fontSize="small" sx={{color: theme.palette.primary.main}} />,
            label: "Edit Port",
            onClick: (e) =>  navigate(`/ports/edit?id=${data.portUid}`),
            requiredPermission: permissions.ports.CHANGE_UPDATE_PORT,
        },
        {
            icon: <UpdateIcon fontSize="small" sx={{color: theme.palette.primary.main, fontSize: 23}} />,
            label: "Update Status",
            onClick: (e) =>  handleUpdateStatus(e),
            requiredPermission: permissions.ports.CHANGE_STATUS_PORT,
        }
    ].filter((item) => hasPermission(item.requiredPermission))

    
    return (
        <>
            <IconButton onClick={handleClick}>
                <MoreVertIcon />
            </IconButton>
  
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{style: {maxHeight: 300}}}
            >
                {menuItems?.map((item, index) => (
                    <MenuItem
                        key={index}
                        onClick={() => {
                            handleClose();
                            item.onClick();
                        }}
                        sx={{}}
                    >
                        <ListItemIcon sx={customIconStyles}>
                            {item.icon}
                        </ListItemIcon>
            
                        <ListItemText sx={{ml: "-3px"}} primary={item.label} />
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}

const ListPortComponent = (props) => {
    const {headers, data} = props;

    const theme = useTheme();

    const [open, setOpen] = useState(false);
    const [selectedPort, setSelectedPort] = useState();
    

    return (
        <Paper elevation={0} sx={{width: "100%", overflow: "hidden", border: "1px solid #e5edf6", boxShadow: "none", borderRadius: 1}}>
            <TableContainer>
                <Table>
                    <TableHead sx={{backgroundColor: "inherit", color: "inherit"}}>
                        <TableRow>
                            {headers.map((header, index) => (
                                <TableCell
                                    key={index}
                                    align="start"
                                    sx={{color: theme.typography.secondary, fontWeight: 600}}
                                >
                                    {header}
                                </TableCell>
                            ))}                   
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {data?.length > 0 ? (
                            data?.map((port) => (
                                <TableRow key={port.id}>
                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary, fontWeight: 600}}>
                                        {port.port_name || "N / A"}
                                    </TableCell>

                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary}}>
                                        {port.type || "N / A"}
                                    </TableCell>

                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary}}>
                                        {port.location || "N / A"}
                                    </TableCell>

                                    <TableCell component="th" scope="row">
                                        <CustomChipComponent category="portStatus"
                                            label={(port.status === "Active") ? "Active" 
                                                : 
                                                    (port.status === "Deactivated") ? "Deactivated"
                                                :
                                                    port.status
                                            }
                                        />
                                    </TableCell>

                                    <TableCell align="start">
                                        <CustomMenuPopperComponent 
                                            data={port} 
                                            setSelectedPort={setSelectedPort}
                                            theme={theme}
                                            setOpen={setOpen}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={headers?.length} align="center">
                                    No port data available to display
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {open && 
                <UpdateStatusDialog 
                    open={open} 
                    setOpen={setOpen} 
                    selectedPort={selectedPort}
                />
            }
        </Paper>
    )
}

export default ListPortComponent